import React, { useState } from 'react'

export default function AddOnPurchase({close, handleSubmit, saving, team}) {
    let cost = team.use_custom_pricing ? team.add_on_cost : 100
  return (
    <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
        <div className="bg-white mx-auto rounded shadow p-5 text-center">
            <h2>Purchase Custom Domain</h2>
            <p>
                The custom domain flag allows you to have your public pages under your own domain and customize the URL of the public page, it goes for a one time payment of $100
            </p>

            <h4>Total Amount: { parseFloat(cost).toFixed(2) } USD</h4>

            <div className="pt-3">
                <button onClick={handleSubmit} type="button" className="btn btn-primary mr-2" disabled={saving}>
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                    Proceed
                </button>

                <button onClick={close} type="button" className="btn btn-danger mr-2" disabled={saving}>
                    Cancel
                </button>
            </div>
        </div>
    </div>
  )
}
